
import React, { useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./CryptoTradingViewChart.css";

import CryptoBottomNav from "../Components/CryptoBottomNav"




export default function CryptoTradingViewChart() {
  const { coin } = useParams();
  const navigate = useNavigate();

  const selectedCoin = decodeURIComponent(
    coin || "BTC-USDT"
  ).toUpperCase();

  const [interval, setInterval] = useState("15");
  const [chartTheme, setChartTheme] = useState("dark");

  const [base, quote = "USDT"] = selectedCoin.split("-");

  // TradingView symbols
  const symbolMap = {
    BTC: "BINANCE:BTCUSDT",
    ETH: "BINANCE:ETHUSDT",
    SOL: "BINANCE:SOLUSDT",
    XRP: "BINANCE:XRPUSDT",
    DOGE: "BINANCE:DOGEUSDT",
    TRX: "BINANCE:TRXUSDT",
    BNB: "BINANCE:BNBUSDT",
    ADA: "BINANCE:ADAUSDT",
    AVAX: "BINANCE:AVAXUSDT",
    OKB: "OKX:OKBUSDT",
  };

  const symbol =
    symbolMap[base] ||
    `BINANCE:${base}${quote}`;

  const timeframeLabels = {
    "1": "1 Minute",
    "5": "5 Minutes",
    "15": "15 Minutes",
    "30": "30 Minutes",
    "60": "1 Hour",
    "240": "4 Hours",
    D: "1 Day",
    W: "1 Week",
    M: "1 Month",
  };

  const chartUrl = useMemo(() => {
    const params = new URLSearchParams({
      symbol,
      interval,
      theme: chartTheme,
      style: "1",
      locale: "en",
      timezone: "Africa/Dar_es_Salaam",
      withdateranges: "1",
      hide_side_toolbar: "0",
      allow_symbol_change: "1",
      saveimage: "1",
      details: "1",
      hotlist: "0",
      calendar: "0",
      studies: "[]",
      support_host: "https://www.tradingview.com",
    });

    return `https://www.tradingview.com/widgetembed/?${params.toString()}`;
  }, [symbol, interval, chartTheme]);

  const handleBack = () => {
    // Rudi ukurasa uliopita; ikiwa hakuna history, nenda home
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <main className="tv-page">
        
<CryptoBottomNav/>
      {/* Top navigation */}
      <nav className="tv-topbar">
        <button
          type="button"
          className="tv-back"
          onClick={handleBack}
        >
          <span className="tv-back-arrow">←</span>
          <span>Back to Signals</span>
        </button>

        <div className="tv-brand">
          <span className="tv-brand-icon">₿</span>
          <span>Crypto<span className="tv-brand-accent">View</span></span>
        </div>

        <div className="tv-market-status">
          <span className="tv-status-dot" />
          Market Chart
        </div>
      </nav>

      {/* Coin header */}
      <section className="tv-coin-header">
        <div className="tv-coin-title">
          <div className="tv-coin-avatar">
            {base.slice(0, 1)}
          </div>

          <div className="tv-coin-heading">
            <div className="tv-coin-name-row">
              <h1>{base}</h1>
              <span className="tv-pair-badge">{quote}</span>
            </div>

            <p>
              {selectedCoin} · TradingView Advanced Chart
            </p>
          </div>
        </div>

        <div className="tv-market-badge">
          <span className="tv-status-dot" />
          Live market data
        </div>
      </section>

      {/* Controls */}
      <section className="tv-toolbar">
        <div className="tv-toolbar-group">
          <label htmlFor="tv-timeframe">
            Timeframe
          </label>

          <select
            id="tv-timeframe"
            value={interval}
            onChange={(e) => setInterval(e.target.value)}
          >
            {Object.entries(timeframeLabels).map(
              ([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              )
            )}
          </select>
        </div>

        <div className="tv-toolbar-group">
          <label htmlFor="tv-theme">
            Chart theme
          </label>

          <select
            id="tv-theme"
            value={chartTheme}
            onChange={(e) => setChartTheme(e.target.value)}
          >
            <option value="dark">Dark</option>
            <option value="light">Light</option>
          </select>
        </div>

        <div className="tv-toolbar-spacer" />

        <div className="tv-timeframe-indicator">
          <span className="tv-status-dot" />
          {timeframeLabels[interval]}
        </div>
      </section>

      {/* TradingView chart */}
      <section className="tv-chart-panel">
        <div className="tv-chart-panel-header">
          <div>
            <h2>{selectedCoin}</h2>
            <p>Price chart · {timeframeLabels[interval]}</p>
          </div>

          <span className="tv-chart-label">
            TradingView
          </span>
        </div>

        <div className="tv-chart-frame">
          <iframe
            key={`${symbol}-${interval}-${chartTheme}`}
            title={`${selectedCoin} TradingView chart`}
            src={chartUrl}
            loading="lazy"
            allowFullScreen
            referrerPolicy="origin"
          />
        </div>
      </section>

      {/* Footer note */}
      <footer className="tv-footer">
        <span className="tv-footer-mark">ⓘ</span>
        <p>
          Chart data and prices are provided by TradingView.
          Confirm the trading pair and exchange before making
          any trading decision.
        </p>
      </footer>
    </main>
  );
}
